/**
 * @generated SignedSource<<6b806e0d4bbf68b8eb5cca1fbda58643>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef$data = {
  readonly __id: string;
  readonly id: string;
  readonly issue: {
    readonly id: string;
  };
  readonly name: string;
  readonly selectedGoals: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsReadviewFull_GoalsReadView">;
  readonly " $fragmentType": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef";
};
export type goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef$key = {
  readonly " $data"?: goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "goals_issueFieldGoalsInlineEditFull_GoalsInlineEditViewWithIsEditable_fragmentRef",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "issue",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ]
      },
      "action": "THROW",
      "path": "issue"
    },
    {
      "kind": "FragmentSpread",
      "name": "goals_issueFieldGoalsReadviewFull_GoalsReadView"
    },
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraGoalConnection",
      "kind": "LinkedField",
      "name": "selectedGoals",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraGoalEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "key"
                }
              ]
            }
          ]
        },
        (v1/*: any*/)
      ],
      "storageKey": "selectedGoals(first:1000)"
    },
    (v1/*: any*/)
  ],
  "type": "JiraGoalsField"
};
})();

(node as any).hash = "46c4ce64c1ccf9c7ee8dc2090f374288";

export default node;
